import { Tabs } from "flowbite-react";
import { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import {
  MdAlignHorizontalLeft,
  MdOutlinePayments,
  MdThumbDownOffAlt,
} from "react-icons/md";
import { FaChartBar, FaMagnifyingGlass } from "react-icons/fa6";
import AdminPaymentsTable from "../components/tables/AdminPaymentsTable";
import AdminCloseTable from "../components/tables/AdminCloseTable";
import { useApplication } from "../contexts/ApplicationContext";

const InvoicesPage = () => {
  const { userPermission } = useApplication();
  const queryClient = useQueryClient();
  const [activeTab, setActiveTab] = useState(0);

  return (
    <>
      <div className="bg-white px-4 py-4 rounded-md shadow-md relative">
        <Tabs
          aria-label="Default tabs"
          id="tab-company-details"
          activeTab={activeTab}
          onActiveTabChange={(tabIndex) => setActiveTab(tabIndex)}
        >
          <Tabs.Item title="Fechamento" icon={FaMagnifyingGlass}>
            <AdminCloseTable isActive={activeTab === 0} />
          </Tabs.Item>
          <Tabs.Item title="Pagamentos" icon={MdOutlinePayments}>
            <AdminPaymentsTable isActive={activeTab === 1} />
          </Tabs.Item>
        </Tabs>
      </div>
    </>
  );
};

export default InvoicesPage;
